/**
 * Datos de ejemplo para Clasificación de recetas (Producción concesionaria).
 * Reemplazar por API cuando exista backend.
 */

export const RECETAS_HIERARCHY = [
  {
    id: 1,
    name: 'Panadería y bollería',
    code: 'PAN',
    description: 'Recetas de pan, bollería y masas.',
    is_active: true,
    subcategories: [
      {
        id: 101,
        name: 'Pan dulce',
        code: 'PAN-DUL',
        is_active: true,
        families: [
          { id: 1001, name: 'Conchas y roles', code: 'CON', description: 'Clásicos de vitrina', is_active: true },
          { id: 1002, name: 'Orejas y cuernitos', code: 'ORE', description: 'Hojaldrados', is_active: true },
        ],
      },
      {
        id: 102,
        name: 'Pan salado',
        code: 'PAN-SAL',
        is_active: true,
        families: [
          { id: 1003, name: 'Baguettes y barra', code: 'BAG', description: 'Pan francés y similares', is_active: true },
        ],
      },
    ],
  },
  {
    id: 2,
    name: 'Postres y repostería',
    code: 'POS',
    description: 'Pasteles, tortas y postres fríos.',
    is_active: true,
    subcategories: [
      {
        id: 201,
        name: 'Pasteles',
        code: 'PAS',
        is_active: true,
        families: [
          { id: 2001, name: 'Tres leches y cremosos', code: '3L', description: 'Pasteles húmedos', is_active: true },
          { id: 2002, name: 'Cheesecake', code: 'CHS', description: 'Base queso y frutas', is_active: true },
        ],
      },
      {
        id: 202,
        name: 'Postres individuales',
        code: 'IND',
        is_active: true,
        families: [
          { id: 2003, name: 'Vasitos y shots', code: 'VAS', description: 'Formato monoporción', is_active: true },
        ],
      },
    ],
  },
  {
    id: 3,
    name: 'Bebidas y complementos',
    code: 'BEB',
    description: 'Bebidas preparadas y salsas.',
    is_active: true,
    subcategories: [
      {
        id: 301,
        name: 'Bebidas calientes',
        code: 'CAL',
        is_active: true,
        families: [
          { id: 3001, name: 'Cafés especiales', code: 'CAF', description: 'Espresso, capuchino, etc.', is_active: true },
        ],
      },
    ],
  },
];

export function getRecetasHierarchy() {
  return RECETAS_HIERARCHY;
}

export function getRecetasCategories() {
  return RECETAS_HIERARCHY.map(({ id, name, code, description, is_active }) => ({
    id,
    name,
    code,
    description,
    is_active,
  }));
}

export function getRecetasSubcategories() {
  const rows = [];
  RECETAS_HIERARCHY.forEach((cat) => {
    cat.subcategories.forEach((sub) => {
      rows.push({
        id: sub.id,
        name: sub.name,
        code: sub.code,
        is_active: sub.is_active,
        category_id: cat.id,
        category_name: cat.name,
      });
    });
  });
  return rows;
}

export function getRecetasFamilies() {
  const rows = [];
  RECETAS_HIERARCHY.forEach((cat) => {
    cat.subcategories.forEach((sub) => {
      sub.families.forEach((fam) => {
        rows.push({
          id: fam.id,
          name: fam.name,
          code: fam.code,
          description: fam.description,
          is_active: fam.is_active,
          subcategory_id: sub.id,
          subcategory_name: sub.name,
          category_id: cat.id,
          category_name: cat.name,
        });
      });
    });
  });
  return rows;
}

/**
 * Nombres de receta de ejemplo por familia (una receta por familia = cobertura total de clasificación).
 */
const DEMO_NOMBRE_RECETA_POR_FAMILIA_ID = {
  1001: 'Concha vainilla',
  1002: 'Oreja rellena de cajeta',
  1003: 'Barra rústica integral 400 g',
  2001: 'Pastel tres leches tradicional',
  2002: 'Cheesecake frutos rojos',
  2003: 'Vasito limón merengue',
  3001: 'Café capuchino planta',
};

/**
 * Listado demo de recetas con toda la jerarquía: categoría → subcategoría → familia.
 */
export function getMockRecetasListado() {
  const rows = [];
  let n = 1;
  RECETAS_HIERARCHY.forEach((cat) => {
    cat.subcategories.forEach((sub) => {
      sub.families.forEach((fam) => {
        const name =
          DEMO_NOMBRE_RECETA_POR_FAMILIA_ID[fam.id] || `Receta ${fam.name}`;
        rows.push({
          code: `R-${String(n).padStart(3, '0')}`,
          name,
          /** Texto único para la columna "Clasificación" (categoría › subcategoría › familia) */
          classification: `${cat.name} › ${sub.name} › ${fam.name}`,
          category: cat.name,
          subcategory: sub.name,
          family: fam.name,
          familyCode: fam.code,
          categoryId: cat.id,
          subcategoryId: sub.id,
          familyId: fam.id,
          active: fam.is_active,
        });
        n += 1;
      });
    });
  });
  return rows;
}

const newLineId = () => `ln-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

/** Unidades típicas para ingredientes (demo). */
export const UNIDADES_INGREDIENTE = ['kg', 'g', 'L', 'ml', 'pza', 'lb'];

/** Valores por defecto de salida de receta (configuración de producción). */
export const RECETA_OUTPUT_DEFAULTS = {
  output_product_type: 'producto_terminado',
  output_quantity: '1',
  output_unit_of_measure: 'unidad',
};

export const RECETA_OUTPUT_PRODUCT_TYPES = [
  { value: 'producto_terminado', label: 'Producto terminado' },
  { value: 'producto_en_proceso', label: 'Producto en proceso' },
];

/** Cómo se usa un PEP al elaborar producto terminado que lo incluye como insumo. */
export const RECETA_PEP_USO_EN_PT_OPTIONS = [
  {
    value: true,
    label: 'Subreceta automática',
    description:
      'Al sacar la guía de producto terminado, se fabrica este PEP un minuto antes (explosión de insumos).',
  },
  {
    value: false,
    label: 'Guía de producto en proceso',
    description:
      'Se produce con su propia guía PEP y se consume del almacén al elaborar el producto terminado.',
  },
];

/**
 * Indica si un PEP debe fabricarse como subreceta al sacar guía PT.
 * @param {boolean|null|undefined} fabricarSubrecetaDesdePt
 * @param {boolean} globalDefault
 */
export function resolveFabricarSubrecetaDesdePt(fabricarSubrecetaDesdePt, globalDefault) {
  if (fabricarSubrecetaDesdePt === null || fabricarSubrecetaDesdePt === undefined) {
    return Boolean(globalDefault);
  }
  return Boolean(fabricarSubrecetaDesdePt);
}

/** Etiqueta para Excel / listados. */
export function pepUsoEnPtLabel(recipe, globalDefault) {
  if (recipe?.output_product_type !== 'producto_en_proceso') return '—';
  return resolveFabricarSubrecetaDesdePt(recipe?.fabricar_subreceta_desde_pt, globalDefault)
    ? 'Subreceta automática'
    : 'Guía PEP';
}

/**
 * Interpreta celda de «Uso en guía PT».
 * @returns {{ ok: true, skip: true } | { ok: true, value: boolean } | { ok: false, error: string }}
 */
export function parsePepUsoEnPtCell(raw) {
  const t = String(raw ?? '').trim();
  if (!t || t === '—' || t === '-' || t.toLowerCase() === 'n/a') {
    return { ok: true, skip: true };
  }
  const norm = t
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/\s+/g, ' ')
    .trim();

  const subreceta = new Set([
    'subreceta automatica',
    'subreceta',
    'automatica',
    'auto',
    'fabricar subreceta',
    'si',
    's',
    '1',
    'true',
    'verdadero',
  ]);
  const guiaPep = new Set([
    'guia pep',
    'guia de producto en proceso',
    'guia independiente',
    'guia pep independiente',
    'pep',
    'no',
    'n',
    '0',
    'false',
    'falso',
  ]);

  if (subreceta.has(norm)) {
    return { ok: true, value: true };
  }
  if (guiaPep.has(norm)) {
    return { ok: true, value: false };
  }

  return {
    ok: false,
    error:
      '«Uso en guía PT» inválido. Use «Subreceta automática» o «Guía PEP» (también Sí/No). Deje vacío o — para no cambiar.',
  };
}

/** Unidades sugeridas para la salida de la receta (incluye unidad por defecto). */
export const UNIDADES_SALIDA_RECETA = ['unidad', 'UN', ...UNIDADES_INGREDIENTE];

/**
 * Ingredientes de ejemplo por código de receta (formulario).
 */
export function getMockIngredientesReceta(codigo) {
  const map = {
    'R-001': [
      { product: 'Harina de trigo', quantity: '0.5', unit: 'kg' },
      { product: 'Azúcar refinada', quantity: '0.15', unit: 'kg' },
      { product: 'Manteca vegetal', quantity: '0.08', unit: 'kg' },
      { product: 'Levadura instantánea', quantity: '0.02', unit: 'kg' },
      { product: 'Huevo', quantity: '2', unit: 'pza' },
    ],
    'R-002': [
      { product: 'Harina', quantity: '0.4', unit: 'kg' },
      { product: 'Manteca', quantity: '0.2', unit: 'kg' },
      { product: 'Cajeta', quantity: '0.15', unit: 'kg' },
    ],
    'R-003': [
      { product: 'Harina integral', quantity: '0.5', unit: 'kg' },
      { product: 'Agua', quantity: '0.3', unit: 'L' },
      { product: 'Sal', quantity: '0.01', unit: 'kg' },
    ],
    'R-004': [
      { product: 'Leche evaporada', quantity: '0.4', unit: 'L' },
      { product: 'Leche condensada', quantity: '0.35', unit: 'L' },
      { product: 'Crema para batir', quantity: '0.25', unit: 'L' },
      { product: 'Huevos', quantity: '4', unit: 'pza' },
    ],
    'R-005': [
      { product: 'Queso crema', quantity: '0.5', unit: 'kg' },
      { product: 'Frutos rojos', quantity: '0.2', unit: 'kg' },
      { product: 'Galleta molida', quantity: '0.15', unit: 'kg' },
    ],
    'R-006': [
      { product: 'Crema de limón', quantity: '0.08', unit: 'L' },
      { product: 'Merengue', quantity: '0.05', unit: 'kg' },
      { product: 'Base galleta', quantity: '0.04', unit: 'kg' },
    ],
    'R-007': [
      { product: 'Café espresso', quantity: '0.03', unit: 'L' },
      { product: 'Leche entera', quantity: '0.15', unit: 'L' },
      { product: 'Espuma leche', quantity: '0.05', unit: 'L' },
    ],
  };
  return map[codigo] || [{ product: '', quantity: '', unit: 'kg' }];
}

/** Convierte filas mock a estado del formulario (con id por fila). */
export function mapIngredientesToFormLines(ingredientes) {
  return ingredientes.map((row) => ({
    id: newLineId(),
    product: row.product,
    quantity: row.quantity,
    unit: row.unit || 'kg',
  }));
}

export function createEmptyIngredientLine() {
  return {
    id: newLineId(),
    product: '',
    quantity: '',
    unit: 'kg',
  };
}
